export default __webpack_public_path__ + "static/media/ceraveHfCleanser.8c020b22.jpg";